import { TFilterKey, TFilters } from '../components/types';

/**
 * Toggle a value in an array by key
 * If the value is already in the array, remove it
 * If the value is not in the array, add it
 *
 * This is used in Filters component to toggle a value in an array by key
 *
 * @param {TFilterKey} key
 * @param {string} value
 */
export const toggleArrayValue = ({
    key,
    value,
    currents,
    setCurrents,
    singleItem = false,
}: {
    key: TFilterKey;
    value: string;
    currents: TFilters;
    setCurrents: (currents: TFilters) => void;
    singleItem?: boolean;
}) => {
    if (singleItem) {
        setCurrents({ ...currents, [key]: [value] });
        return;
    }

    const currentValue = currents[key];
    const exists = Array.isArray(currentValue)
        ? currentValue.includes(value)
        : false;

    const next = exists
        ? Array.isArray(currentValue)
            ? currentValue.filter((v) => v !== value)
            : []
        : Array.isArray(currentValue)
          ? [...currentValue, value]
          : [value];

    setCurrents({ ...currents, [key]: next });
};
